import { useTranslate } from 'react-polyglot';

import { LockIcon, UnlockIcon } from '@genially/icons';

import { useHostGameContext } from '../../../../HostGame.context';
import { useToggleSessionLocked } from '../../../../hooks/useToggleSessionLocked';
import { SidebarLink } from '../SidebarLink/SidebarLink';

export const LockSessionSidebarLink = () => {
  const t = useTranslate();
  const { settingsSidebar } = useHostGameContext();
  const { isSessionLocked, toggleIsSessionLocked } = useToggleSessionLocked();

  const handleClick = () => {
    settingsSidebar.close();
    toggleIsSessionLocked();
  };

  return (
    <SidebarLink
      Icon={isSessionLocked ? LockIcon : UnlockIcon}
      text={
        isSessionLocked
          ? t('__new.play.creatorLobby.join.QRinstructions.menu.sessionUnblock')
          : t('__new.play.creatorLobby.join.QRinstructions.menu.sessionBlock')
      }
      onClick={handleClick}
    />
  );
};
